<script lang="ts">
    import Modal from "@frontend/Components/Modal.svelte";
    import AddGroupLimit from "@frontend/Components/AddGroupLimit.svelte";
    import EditGroupLimit from "@frontend/Components/EditGroupLimit.svelte";
    import { service } from "@frontend/services";
    import { GetCachedToken, me } from "@frontend/user";
    import { push } from "svelte-spa-router";
    import { get } from "svelte/store";
    import { groups, RefreshGroups } from "@frontend/grouplist";
    import { groupLimits, RefreshGroupLimits } from "@frontend/grouplimitlist";
    import { onMount } from "svelte";
    import Pagination from "@frontend/Components/Pagination.svelte";
    import { translate, currentLanguage } from "../Translator";
    import type { GroupLimitResponse, GroupDTO, AuthenticatedRequestOfDisableGroupLimitDto } from "@frontend/walletapi";
    let currentPage = 1;
    const pageSize = 20;
    $: visibleGroupLimits = $groupLimits.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    type EditAction = {
      action: "edit",
      grouplimitid: number;
    };

    type AddAction = {
      action: "add"
    };

    type RouteParams =
      EditAction |
      AddAction |
      undefined;
    
    export let params: RouteParams = undefined;

    let selectedGroupLimit: GroupLimitResponse | undefined = undefined;
    $: if (params) {
      if (params.action === "edit") {
        const groupLimitId = Number(params.grouplimitid);
        selectedGroupLimit = $groupLimits.find(gl => gl.Id === groupLimitId);
        
        console.log('GroupLimit encontrado:', selectedGroupLimit);
      }
    }

    // Función para obtener el nombre del grupo
    function getGroupName(groupId: number | undefined): string {
      if (!groupId) return 'N/A';
      const group = $groups.find(g => g.Id === groupId);
      return group ? group.Name || 'Sin nombre' : `ID: ${groupId}`;
    }

    // Función para formatear el dinero
    function formatMoney(amount: any): string {
      if (!amount) return '$0.00';
      const num = typeof amount === 'object' ? amount.InCents / 100 || 0 : Number(amount);
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(num);
    }

    // Función para formatear la fecha
    function formatDate(date: Date | string | undefined): string {
      if (!date) return 'N/A';
      try {
        const dateObj = typeof date === 'string' ? new Date(date) : date;
        return dateObj.toLocaleDateString('es-ES', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (error) {
        return 'N/A';
      }
    }

    function dismiss() {
      push("/GroupLimit");
    }

    let errorMessage = '';
    let successMessage = '';

    let showDeleteModal = false;
    let groupLimitToDelete: GroupLimitResponse | null = null;

    function openDeleteModal(groupLimit: GroupLimitResponse) {
        groupLimitToDelete = groupLimit;
        showDeleteModal = true;
    }

    function closeDeleteModal() {
        groupLimitToDelete = null;
        showDeleteModal = false;
    }


    async function confirmDeleteGroupLimit() {
        if (groupLimitToDelete) {
            // Aquí implementarías la lógica de eliminación
            // Por ahora solo cerramos el modal
            closeDeleteModal();
            //successMessage = 'Group limit eliminado exitosamente.';
              successMessage = $translate('Group limit deleted successfully.');
            setTimeout(() => {
                successMessage = '';
            }, 3000);
        }
    }

    async function toggleGroupLimitStatus(groupLimit: GroupLimitResponse) {
        try {
            const requestPayload: AuthenticatedRequestOfDisableGroupLimitDto = {
                Token: GetCachedToken(),
                Data: {
                    Id: groupLimit.Id,
                    Active: !groupLimit.Active
                }
            };

            const result = await service.walletapi.disableGroupLimit(requestPayload);

            if (result.Success) {
                successMessage = result.Message || `Group limit ${groupLimit.Active ? 'disabled' : 'enabled'} successfully.`;
                setTimeout(() => {
                    successMessage = '';
                }, 3000);
                await RefreshGroupLimits();
            } else {
                errorMessage = result.ErrorMessage || 'Error changing group limit status.';
                setTimeout(() => {
                    errorMessage = '';
                }, 3000);
            }
        } catch (error) {
            errorMessage = 'Connection error. Please try again..';
            setTimeout(() => {
                errorMessage = '';
            }, 3000);
        }
    }

    onMount(async () => {
      if (!$me) {
        push("/user/Login");
        return;
      }
      // Cargar los datos iniciales
      await Promise.all([RefreshGroupLimits(), RefreshGroups()]);
    });
  </script>

  <style>
    .group-limit-row {
      transition: background-color 0.2s;
    }
    .group-limit-row:hover {
      background-color: #f5f5f5 !important;
    }
    .balance-positive {
      color: #21ba45;
      font-weight: bold;
    }
    .balance-negative {
      color: #db2828;
      font-weight: bold;
    }
    .balance-zero {
      color: #767676;
      font-weight: bold;
    }
    .floating-error {
      position: absolute;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 10;
      width: 60%;
      max-width: 600px;
      text-align: center;
      pointer-events: none;
    }
    .floating-success {
      position: absolute;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 10;
      width: 60%;
      max-width: 600px;
      text-align: center;
      pointer-events: none;
    }
    .button-separator {
      display: inline-block;
      width: 1px;
      height: 24px;
      background: #ccc;
      margin: 0 8px;
      vertical-align: middle;
    }
    .balance-cell {
      text-align: right;
      font-family: monospace;
    }
    
    .status-button {
      cursor: pointer;
      transition: all 0.2s ease;
      border: none;
      padding: 0.5em 1em;
      font-weight: bold;
      min-width: 80px;
    }
    
    .status-button:hover {
      transform: scale(1.05);
      box-shadow: 0 2px 8px rgba(0,0,0,0.2);
    }
    
    .status-button:active {
      transform: scale(0.95);
    }
  </style>
  
  {#if params?.action == "add"}
    <Modal dismiss={dismiss}>
      <AddGroupLimit {dismiss}/>
    </Modal>
  {/if}

  {#if params?.action == "edit"}
    <Modal dismiss={dismiss}>
      {#if !selectedGroupLimit}
        <div class="ui negative message">
          <div class="header">Error</div>
          <p>Group limit not found</p>
          <p>Go looking: {params?.grouplimitid}</p>
          <p>Total available limits: {$groupLimits.length}</p>
          <button class="ui button" on:click={() => RefreshGroupLimits()}>
            <i class="refresh icon"></i>
            Reload data
          </button>
        </div>
      {:else}
        <EditGroupLimit {dismiss} groupLimit={selectedGroupLimit} />
      {/if}
    </Modal>
  {/if}

  {#if showDeleteModal}
    <Modal dismiss={closeDeleteModal}>
      <div class="ui header">Confirmar</div>
      <div>{$translate ('Are you sure you want to delete the group')}</div>
      <div style="margin-top: 2em; display: flex; gap: 1em; justify-content: flex-end;">
        <button class="ui button" on:click={closeDeleteModal}>Cancel</button>
        <button class="ui red button" on:click={confirmDeleteGroupLimit}>Delete</button>
      </div>
    </Modal>
  {/if}


  <h1 class="ui centered dividing header">{$translate('Group limit')} ({$groupLimits.length ?? 0})</h1>

  <a class="ui positive button" href="#/GroupLimit/add">
    <i class="plus icon"></i>
   {$translate('Add Group')}
  </a>

  <div class="table-container" style="position: relative;">
    {#if errorMessage}
      <div class="ui negative message floating-error">
        <div class="header">Error</div>
        <p>{errorMessage}</p>
      </div>
    {/if}
    {#if successMessage}
      <div class="ui positive message floating-success">
        <div class="header">Éxito</div>
        <p>{successMessage}</p>
      </div>
    {/if}

    <table class="ui celled unstackable striped very compact unselectable table">
      <thead>
        <tr>
          <th style="width: 60px">#</th>
          <th>{$translate('Group')}</th>
          <th>{$translate('User')}</th>
          <th style="width: 150px; text-align: right">{$translate('Balance')}</th>
          <th style="width: 150px; text-align: right">{$translate('Balance')}</th>
          <th style="width: 150px">{$translate('Date Transaction')}</th>
          <th style="width: 100px">{$translate('Active')}</th>
          <th style="width: 120px">{$translate('Options')}</th>
        </tr>
      </thead>
      <tbody>
        {#each visibleGroupLimits as groupLimit}
          <tr class="group-limit-row">
            <td class="numeric">{groupLimit.Id}</td>
            <td>
              <div class="group-name">
                {getGroupName(groupLimit.GroupId)}
                {#if groupLimit.GroupId}
                  <span class="ui tiny label">ID: {groupLimit.GroupId}</span>
                {/if}
              </div>
            </td>
            <td>
              {#if groupLimit.UserId}
                <span class="ui tiny label">{groupLimit.UserId}</span>
              {:else}
                <span class="ui tiny grey label">N/A</span>
              {/if}
            </td>
            <td class="balance-cell">
              <span class="balance-positive">{formatMoney(groupLimit.InitialBalance)}</span>
            </td>
            <td class="balance-cell">
              {#if groupLimit.Balance}
                {@const balance = groupLimit.Balance}
                {@const balanceAmount = typeof balance === 'object' ? balance.InCents / 100 || 0 : Number(balance)}
                <span class={balanceAmount > 0 ? 'balance-positive' : balanceAmount < 0 ? 'balance-negative' : 'balance-zero'}>
                  {formatMoney(groupLimit.Balance)}
                </span>
              {:else}
                <span class="balance-zero">$0.00</span>
              {/if}
            </td>
            <td>
              {formatDate(groupLimit.DateTransaction)}
            </td>
            <td>
              <button 
                class="ui {groupLimit.Active ? 'green' : 'red'} label status-button" 
                on:click={() => toggleGroupLimitStatus(groupLimit)}
                title={groupLimit.Active ? $translate('Click to Disable') : $translate('Click to Enable')}
              >
                {groupLimit.Active ? $translate('Active') : $translate('Inactive')}
              </button>
            </td>
            <td>
              <div class="ui icon buttons">
                <a href="#/GroupLimit/edit/{groupLimit.Id}" class="ui button" title={$translate('Edit')}>
                  <i class="edit icon"></i>
                </a>
                <span class="button-separator"></span>
                <a 
                  href="#/GroupLimitTransactions/{groupLimit.Id}" 
                  class="ui blue icon button" 
                  title={$translate('View Transactions')}
                >
                  <i class="list icon"></i>
                </a>
                <!-- <span class="button-separator"></span>
                <button class="ui red icon button" on:click={() => openDeleteModal(groupLimit)} title="Eliminar">
                  <i class="trash icon"></i>
                </button> -->
              </div>
            </td>
          </tr>
        {/each}
      </tbody>
    </table>
    <Pagination page={currentPage} totalItems={$groupLimits.length} {pageSize} on:change={(event) => currentPage = event.detail} />

    {#if $groupLimits.length === 0}
      <div class="ui placeholder segment">
        <div class="ui icon header">
          <i class="chart line icon"></i>
           No group limits are configured.
        </div>
        <p>No group limits have been found in the system..</p>
      </div>
    {/if}
  </div>
